var React = require('react');

function HouseFireInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.112 0h-.36L0 11.312v.267h4.597v17h8.378c-2.83-2.524-3.408-8.936.04-12.753h.213c-.066.787.093 2.202.292 2.843.272.874 1.37.934 1.493-.036.453-3.584 1.92-6.84 4.615-8.823h.28c-.173 3.475.122 6.114 1.11 8.164.355.737 1.18.66 1.315-.15.17-1.013.24-2.09.258-2.92h.216c3.156 4.136 3.303 9.97-.054 13.676h8.51v-17h4.597v-.267z","fill":"#ff7254"}));
}

HouseFireInline.defaultProps = {"width":"135.547","height":"108.052","viewBox":"0 0 35.863 28.589"};

module.exports = HouseFireInline;

HouseFireInline.default = HouseFireInline;
